<div class="territory-search-home-container">
  <div class="department-selection">
    <div>
      <div class="selection-title">{{ 'territory-search.title' | translate }}</div>
      <div class="selection-subtitle">{{ 'territory-search.subtitle' | translate }}</div>
    </div>
    <div class="department-input-container">
      @if (dropdownItems.length) {
        <ex-dropdown
          [items]="dropdownItems"
          (valueChange)="departmentChange($event)"
          [placeholder]="'territory-search.choose-territory' | translate"
          class="department-input"
        >
        </ex-dropdown>
        <ex-button #searchButton size="x-large" [disabled]="!selectedUid" class="search-button" (click)="onSubmitTerritory()">
          {{ 'territory-search.submit' | translate }}
        </ex-button>
      } @else {
        <app-simple-loader [size]="40"></app-simple-loader>
      }
    </div>
  </div>
  <div class="features-blog">
    @for (feature of features; let i = $index; track feature) {
      <div
        class="feature-card"
        [ngClass]="{ clickable: feature.modalComponent }"
        (click)="feature.modalComponent && modalService.open(feature.modalComponent, { centered: true, windowClass: 'modal-auto' })"
      >
        <div class="feature-thumbnail-container">
          <!--@if (i === 0) {
            <ex-badge
              class="new-badge"
              icon="sparks-filled"
              backgroundColor="var(--ex-transparent-ai-8)"
              borderColor="var(--ex-transparent-ai-16)"
              color="var(--color-semantic-ai-bg)"
              [text]="'common.new' | translate | uppercase"
            ></ex-badge>
          }-->
          <img class="feature-thumbnail" [src]="feature.image" alt="smart-search-thumbnail" />
        </div>
        <div class="feature-content">
          <div class="feature-title">{{ feature.title | translate }}</div>
          <div class="feature-subtitle">{{ feature.subtitle | translate }}</div>
        </div>
      </div>
    }
  </div>
</div>
